<template>
  <div>
    <div class="mask" v-if="isShowRule">
      <div class="contanier">
        <div class="rules">
          <div class="rulesTitle">规则说明</div>
          <!-- <div class="ruleDesc">活动规则</div> -->
          <div class="rulesContent">
            <div class="item" v-for="(item, index) in ruleList" :key="index">{{item}}</div>
          </div>
        </div>

        <div class="close" @click="close">
          <img src="https://cdn.133.cn/gtgj/icon/server/2018/04/xx@2x.png" alt="">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "share",
    props: ["isShowRule"],
    data() {
      return {
        ruleList: [
          '1. 活动期间，每位用户可凭手机号免费领取1个月高铁管家黄金会员权益1次。',
          '2. 领取成功后，请下载高铁管家客户端查看及使用，有效期自领取成功1个月内。',
          '3. 如果出现恶意舞弊、违规行为，高铁管家有权取消该用户的活动资格，并有权撤销由该行为产生的所有权益，严重时可追究其法律责任。',
          '4.本活动法律范围内最终解释权归高铁管家官方所有。'
        ],
        ruleTime: ""
      }
    },
    methods: {
      close() {
        this.$emit("close");
      }
    },

  };
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';
  @import '../style/common.scss';
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.75);
  }
  .contanier {
    position: absolute;
    width: 84%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
  }

  .rules {

    background: #ffffff;
    border-radius: 8*$px;
    padding: 0 24*$px;
    max-height: 460*$px;
    overflow: scroll;
    padding-bottom: 40*$px;
    font-size: 12*$px;
    .rulesTitle {
      font-size: 24*$px;
      color: #000000;
      text-align: center;
      font-weight: 500;
      padding-top: 27*$px;
      padding-bottom: 16*$px;
    }
    .rulesTime {
      font-size: 12*$px;
      color: #000000;
      padding-bottom: 16*$px;
      span {
        font-weight: 600;
      }
    }
    .ruleDesc {
      margin-bottom: 4*$px;
      font-weight: 600;
    }
    .rulesContent {
      font-size: 12*$px;
      color: #000000;
      padding-bottom: 24*$px;
      .oneRule {
        margin-bottom: 18*$px;
        line-height: 18*$px;
      }
      .item {
        margin-bottom: 20*$px;
      }
    }
  }
  .close {
    text-align: center;
    margin-top: 24*$px;
    img {
      width: 36*$px;
      height: 36*$px;
      margin: 0 auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/sikuGold/components/rule.vue